import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/places?all=1`)
  return data.data
}

export const usePlaces = () => {
  const { data, ...props } = useQuery(
    queryKeys.PLACES,
    () => getData(),
  )
  return { data, ...props }
}
